<script setup lang="ts">
  import { Check, Eye, RotateCcw, X } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";

  withDefaults(
    defineProps<{
      showOriginal?: boolean;
    }>(),
    {
      showOriginal: false,
    },
  );

  defineEmits<{
    accept: [];
    toggle: [];
    retry: [];
    cancel: [];
  }>();
</script>

<template>
  <div
    class="flex max-w-full flex-wrap items-center gap-1 rounded-md border bg-popover px-1.5 py-1">
    <Button
      type="button"
      size="sm"
      class="h-7"
      @click="$emit('accept')">
      <Check class="h-3.5 w-3.5 mr-1" />
      Replace
    </Button>
    <Button
      type="button"
      variant="ghost"
      size="sm"
      class="h-7"
      @click="$emit('toggle')">
      <Eye class="h-3.5 w-3.5 mr-1" />
      {{ showOriginal ? "View AI version" : "View original" }}
    </Button>
    <Button
      type="button"
      variant="ghost"
      size="sm"
      class="h-7"
      @click="$emit('retry')">
      <RotateCcw class="h-3.5 w-3.5 mr-1" />
      Retry
    </Button>
    <Button
      type="button"
      variant="ghost"
      size="icon"
      class="h-7 w-7"
      @click="$emit('cancel')">
      <X class="h-3.5 w-3.5" />
    </Button>
  </div>
</template>
